// components/ThemeToggle.js — small sun/moon button to flip light/dark
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

export default function ThemeToggle({ size = 'md', variant = 'ghost' }) {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';
  const className =
    variant === 'ghost'
      ? `btn btn-ghost btn-icon ${size === 'sm' ? 'btn-sm' : ''}`
      : `btn btn-secondary btn-icon ${size === 'sm' ? 'btn-sm' : ''}`;

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={className}
      title={isLight ? 'Switch to dark theme' : 'Switch to light theme'}
      aria-label={isLight ? 'Switch to dark theme' : 'Switch to light theme'}
    >
      <span style={{ fontSize: '1.1rem', lineHeight: 1 }}>{isLight ? '🌙' : '☀️'}</span>
    </button>
  );
}
